import { useEffect, useState } from "react";

import { DataTable, PageHeader } from "@/components/admin-ui";
import { adminOpsClient } from "@/lib/api-clients";

export function PlansPage() {
  const [rows, setRows] = useState<Array<[string, string, string, string]>>([]);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    void adminOpsClient
      .listSubscriptionPlans()
      .then((plans) => {
        setRows(
          plans.map((plan) => [
            plan.code,
            plan.name,
            String(plan.price),
            plan.isFree ? "FREE" : plan.billingInterval,
          ]),
        );
      })
      .catch((err) => setError(err instanceof Error ? err.message : "โหลดไม่สำเร็จ"));
  }, []);

  return (
    <div className="space-y-6">
      <PageHeader title="แพ็กเกจสมาชิก" />
      {error ? <p className="text-sm text-error-text">{error}</p> : null}
      <DataTable headers={["Code", "Name", "Price", "Interval"]} rows={rows} />
    </div>
  );
}
